import {
  allRounderIcon,
  ballIcon,
  batIcon,
  default_Photo,
  keeperIcon,
} from "../../../Assets";
import {
  formatToIndianCurrencyWords2,
  mapHighestLevelToCategory,
} from "../../../Utils/helperFunctions";
import { resolveCategoryWithFallback } from "../../../Utils/auctionRules";

export const stripe =
  "linear-gradient(90deg, #e41f4f 0%, #e41f4f 12%, #24c864 12%, #24c864 26%, #1ba8ff 26%, #1ba8ff 40%, #4e5dff 40%, #4e5dff 54%, #ff8b1a 54%, #ff8b1a 67%, #ff3e4d 67%, #ff3e4d 79%, #ffd400 79%, #ffd400 90%, #22d37b 90%, #22d37b 100%)";

export const getTeamLogo = (team: any) => {
  const logo = team?.Logo_URL__c;
  return typeof logo === "string" && logo.trim() ? logo.trim() : "";
};

export const getPlayerPhoto = (player: any) => {
  const photo =
    player?.photo ||
    player?.Player__r?.Photo_URL__c ||
    player?.Player__r?.Profile_Image__c ||
    player?.Photo_URL__c;
  return typeof photo === "string" && photo.trim() ? photo : default_Photo;
};

export const getPlayerName = (player: any) =>
  `${player?.firstName || ""} ${player?.lastName || ""}`.trim() ||
  player?.name ||
  player?.Player__r?.Name ||
  "-";

export const getRoleIcon = (role: string) => {
  const normalized = role.toLowerCase();
  if (normalized.includes("bow")) return ballIcon;
  if (normalized.includes("keeper") || normalized.includes("wicket")) {
    return keeperIcon;
  }
  if (normalized.includes("all")) return allRounderIcon;
  return batIcon;
};

export const compactCurrency = (value: any) => {
  const toShortL = (text: string) =>
    text.replace(/\bLakhs?\b/gi, "L").replace(/\s+/g, " ").trim();

  if (typeof value === "number") {
    return toShortL(formatToIndianCurrencyWords2(value));
  }
  if (typeof value === "string" && value.trim()) {
    const cleaned = value.trim();
    if (cleaned === "-") return "-";
    const normalized = toShortL(cleaned);
    return normalized.startsWith("₹") ? normalized : `₹${normalized}`;
  }
  return "-";
};

export const isIconPlayer = (player: any) => {
  const recentA = String(player?.recentCompetetionLevel || "").toLowerCase();
  const recentB = String(player?.recentCompetitionLevel || "").toLowerCase();
  const highest = String(player?.highest_level_played || "").toLowerCase();
  const mcaNo =
    player?.MCANo ||
    player?.MCA_No__c ||
    player?.MCA_Registration_Number__c ||
    player?.Player__r?.MCA_No__c ||
    player?.Player__r?.MCA_Registration_Number__c;
  const category = String(
    resolveCategoryWithFallback({
      division:
        String(player?.gender || "").toLowerCase() === "female"
          ? "women"
          : "men",
      mcaNo,
      fallbackCategory:
        player?.playerCategory ||
        player?.category ||
        mapHighestLevelToCategory(
          player?.recentCompetetionLevel ||
            player?.recentCompetitionLevel ||
            player?.highest_level_played ||
            "",
        ) ||
        "",
    }) || "",
  ).toLowerCase();

  return (
    recentA === "indian senior team" ||
    recentB === "indian senior team" ||
    highest === "indian senior team" ||
    category === "icon player"
  );
};
